const getters = {
  evaluacionEnCurso (state: any) {
    return {
      reviewsAnswerId: state.reviewsAnswerId,
      preguntas: state.preguntas,
      tiempoDisponible: state.tiempoDisponible,
      dateCreation: state.dateCreation
    }
  },
  resultado (state: any) {
    return state.resultado
  },
  cargando (state: any) {
    return state.cargando
  }
}

export default getters
